import React from 'react';
import { Route } from 'react-router-dom';
import { isRootAdmin } from '../../utilities/keycloakUtils';
import RootAdminContainer from './RootAdminContainer';

const RootAdminRoute = ({
  component: Component,
  auth,
  store,
  profile,
  exact = false,
  ...rest
}) => {
  return (
    <Route
      exact={exact}
      {...rest}
      render={(props) =>
        !!auth.authenticated && isRootAdmin(auth) ? (
          <Component {...props} />
        ) : (
          <RootAdminContainer {...props} />
        )
      }
    />
  );
};

export default RootAdminRoute;
